interface ModalState {
  modal: string | null;
  modalButton: HTMLButtonElement | null;
  modalProps: Record<string, any>;
}

const useModalStore = () => {
  const modalState = useState<ModalState>("modalState", () => {
    return {
      modal: null,
      modalButton: null,
      modalProps: {},
    };
  });

  const closeModal = () => {
    modalState.value.modal = null;

    if (modalState.value.modalButton) {
      modalState.value.modalButton.focus();
      modalState.value.modalButton = null;
    }

    pageScrollUnblock();
  };

  const isModalOpen = (modal: string | null = null) => {
    if (modal) {
      return modalState.value.modal === modal;
    }

    return Boolean(modalState.value.modal);
  };

  const openModal = (modal: string, event: Event | null = null, props: Record<string, any> = {}) => {
    pageScrollBlock();

    if (event) {
      modalState.value.modalButton = event.target as HTMLButtonElement;
    }

    modalState.value.modal = modal;
    modalState.value.modalProps[modal] = props;
  };

  const getModalProps = (modal: string) => {
    return modalState.value.modalProps[modal] || {};
  };

  return {
    closeModal,
    isModalOpen,
    openModal,
    modalProps: computed(() => modalState.value.modalProps),
  };
};

export { useModalStore };
